// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';
// =================Dependancies==================
import {
  Typography, Modal, Box, Fade, Backdrop,
} from '@mui/material';
// =================React Hook==================
import { useDispatch, useSelector } from 'react-redux';
import { setOpenModal } from '../../../actions/file';

// =================const modal style=================
const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  border: '1px solid grey',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
};

const styleItalic = {
  fontWeight: 'bold',
  fontStyle: 'italic',
  marginTop: '3em',
};

// const stylePadding = {
//   paddingBottom: '1em',
// };

function Modaldownload() {
  // ==================HOOK=========================
  const dispatch = useDispatch();

  const openModal = useSelector((state) => state.files.modal.openModal);

  const filesData = useSelector((state) => state.files.dataFiles);

  const filesSelected = useSelector((state) => state.files.grid.filesSelected);

  const fileClicked = useSelector((state) => state.files.fileClicked);

  // ================Handler=======================
  const handleCloseModal = () => {
    dispatch(setOpenModal(false));
  };

  // =================Function====================

  // Function allowing you to download the selected file in the requested format
  function downloadSelectedFiles(filename, format) {
    const filesArray = [];
    if (filesSelected.length > 0) {
      for (let i = 0; i < filesSelected.length; i += 1) {
        for (let j = 0; j < filesData.length; j += 1) {
          if (filesSelected[i].file_name === filesData[j].name) {
            filesArray.push(filesData[j]);
          }
        }
      }
      if (format === 'sh') {
        let scriptText = '';
        let link = '';
        for (let i = 0; i < filesArray.length; i += 1) {
          if (filesArray[i].data_center.data_center_structure.directory_naming !== '') {
            console.log(filesArray[i]);
            link = `${filesArray[i].data_center.protocol}://${filesArray[i].data_center.hostname}/${filesArray[i].data_center.data_center_structure.directory_naming}/${filesArray[i].relative_path}/${filesArray[i].name}`;
          }
          else {
            link = `${filesArray[i].data_center.protocol}://${filesArray[i].data_center.hostname}/${filesArray[i].relative_path}/${filesArray[i].name}`;
          }
          scriptText = `${scriptText} wget ${link}\n`;
        }

        const blob = new Blob([scriptText], { type: 'text/plain' });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, filename);
        }
        else {
          const elem = window.document.createElement('a');
          elem.href = window.URL.createObjectURL(blob);
          elem.download = filename;
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        }
      }
      else if (format === 'txt') {
        let scriptText = '';
        let link = '';
        for (let i = 0; i < filesArray.length; i += 1) {
          if (filesArray[i].data_center.data_center_structure.directory_naming !== '') {
            link = `${filesArray[i].data_center.protocol}://${filesArray[i].data_center.hostname}/${filesArray[i].data_center.data_center_structure.directory_naming}/${filesArray[i].relative_path}/${filesArray[i].name}`;
          }
          else {
            link = `${filesArray[i].data_center.protocol}://${filesArray[i].data_center.hostname}/${filesArray[i].relative_path}/${filesArray[i].name}`;
          }
          scriptText = `${scriptText + link}\r\n`;
        }

        const blob = new Blob([scriptText], { type: 'text/plain' });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, filename);
        }
        else {
          const elem = window.document.createElement('a');
          elem.href = window.URL.createObjectURL(blob);
          elem.download = filename;
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        }
      }
    }
  }

  function download() {
    const filesArray = [];
    const files = [];
    if (filesSelected.length > 0) {
      for (let i = 0; i < filesSelected.length; i += 1) {
        for (let j = 0; j < filesData.length; j += 1) {
          if (filesSelected[i].file_name === filesData[j].name) {
            filesArray.push(filesData[j]);
          }
        }
      }
      let link = '';
      for (let i = 0; i < filesArray.length; i += 1) {
        if (filesArray[i].data_center.data_center_structure.directory_naming !== '') {
          link = `${filesArray[i].data_center.protocol}://${filesArray[i].data_center.hostname}/${filesArray[i].data_center.data_center_structure.directory_naming}/${filesArray[i].relative_path}/${filesArray[i].name}`;
        }
        else {
          link = `${filesArray[i].data_center.protocol}://${filesArray[i].data_center.hostname}/${filesArray[i].relative_path}/${filesArray[i].name}`;
        }
        files.push(link);
      }
      files.forEach((file) => {
        if (openModal) {
          window.open(file);
        }
      });
    }
    else if (fileClicked.length > 0) {
      for (let j = 0; j < filesData.length; j += 1) {
        if (fileClicked === filesData[j].name) {
          filesArray.push(filesData[j]);
        }
      }
      let link = '';
      for (let i = 0; i < filesArray.length; i += 1) {
        if (filesArray[i].data_center.data_center_structure.directory_naming !== '') {
          link = `${filesArray[i].data_center.protocol}://${filesArray[i].data_center.hostname}/${filesArray[i].data_center.data_center_structure.directory_naming}/${filesArray[i].relative_path}/${filesArray[i].name}`;
        }
        else {
          link = `${filesArray[i].data_center.protocol}://${filesArray[i].data_center.hostname}/${filesArray[i].relative_path}/${filesArray[i].name}`;
        }
        files.push(link);
      }
      files.forEach((file) => {
        if (openModal) {
          window.open(file);
        }
      });
    }
  }

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 600,
        },
      }}
    >
      <Fade in={openModal}>
        <Box sx={styleModal}>
          <Typography id="modal-modal-title" variant="h4" component="h2">
            Download
          </Typography>
          <Box>
            {/* <p style={styleItalic}>
                    Direct file download was previously disabled due to browser
                    policy change. Downloading from ftp link is no longer supported.
                  </p> */}
            {/* <p style={stylePadding}>
                    We are currently in active research to find and implement a solution
                  </p> */}
            <p style={styleItalic}>
              You can download the files by clicking on the  following link.
              Note that you need to ensure that your browser allows the opening of several popups
              (see this <a href="https://support.mozilla.org/en-US/kb/pop-blocker-settings-exceptions-troubleshooting">link</a> for
              firefox, and this <a href="https://support.google.com/chrome/answer/95472?hl=en&co=GENIE.Platform%3DDesktop#zippy=%2Callow-pop-ups-and-redirects-from-a-site">link</a> for chrome).
            </p>

            <ol className="modal--list">
              <li>Direct Download: <button className="download--button" type="button" onClick={() => download()}>Download</button></li>
            </ol>

            <p> The following alternatives can still be used :</p>
            <ol className="modal--list">
              <li> The python command line client: <a className="download--link" href="https://gitlab.com/gpseurope/pyglass/-/releases" target="_blank" rel="noreferrer">Click here (Documentation included)</a></li>
              <li> A script to download the files with wget: <button className="download--button" type="button" onClick={() => downloadSelectedFiles('eposwget.sh', 'sh')}>Click here</button></li>
              <li> A list of the file URL to download the file with any software: <button className="download--button" type="button" onClick={() => downloadSelectedFiles('eposfilelist.txt', 'txt')}>Click here</button></li>
            </ol>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default Modaldownload;
